import { Checkbox, CheckboxProps } from '@innovationnorway/cl-react';
import React from 'react';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { CountyWithMunicipalities, Municipalities } from 'src/features/one-way-in/hooks/use-geonorge';
import { TargetData } from '../hooks/subforms/use-target-form';

type Props = {
  row: { original: CountyWithMunicipalities };
  municipalities: string[];
  getValues: UseFormGetValues<TargetData>;
  setValue: UseFormSetValue<TargetData>;
};

const CountyMunicipalities: React.FC<Props> = ({ row, municipalities, getValues, setValue }) => {
  const municipalityOptions: CheckboxProps[] = React.useMemo(() => {
    return row.original.kommuner
      .sort((a, b) => a.kommunenavnNorsk.localeCompare(b.kommunenavnNorsk, 'nb-NO'))
      .map((municipality: Municipalities) => ({
        value: municipality.kommunenummer,
        label: municipality.kommunenavnNorsk,
        checked: municipalities.includes(municipality.kommunenummer),
      }));
  }, [row.original.kommuner, municipalities]);

  const handleOnChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { checked, value } = e.currentTarget;

    const currentMunicipalities = getValues('municipalities') || [];

    if (checked) {
      if (!currentMunicipalities.includes(value)) {
        setValue('municipalities', [...currentMunicipalities, value]);
      }
    } else {
      setValue(
        'municipalities',
        currentMunicipalities.filter((municipalityId) => municipalityId !== value),
      );
    }
  };

  return (
    <div className="margin-left--5">
      {municipalityOptions.map((e) => (
        <Checkbox
          className="margin-bottom--2"
          key={String(e.value)}
          name="municipalities"
          {...e}
          onChange={handleOnChange}
        />
      ))}
    </div>
  );
};

export default CountyMunicipalities;
